module.exports = __webpack_public_path__ + "static/img/2.39c38fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news29/2.png
// module id = Vmd7
// module chunks = 1